import { AccessLevel } from '@mnd-frontend/graphql-schema';
import { SHADOW_2 } from '@mnd-frontend/ui';
import { animated, useTransition } from '@react-spring/web';
import type React from 'react';
import styled, { css } from 'styled-components';

const StyledIconPopup = styled.div<{ $newNavigation: boolean }>`
  background-color: #ffffff;
  box-shadow: ${SHADOW_2};

  bottom: 2rem;
  left: 0;
  margin: 1rem;
  padding: 1rem;
  position: fixed;
  z-index: 1999;
  ${props =>
    props.$newNavigation &&
    css`
      position: static;
      box-shadow: none;
      margin: 0;
      padding: 0;
    `}
`;

type CookieOverviewProps = {
  locale?: string;
  show: boolean;
  version?: string;
  viewAsAdmin: boolean;
  accessLevel?: AccessLevel;
  newNavigation?: boolean;
};

const CookieOverview: React.FC<CookieOverviewProps> = ({
  locale,
  show,
  version,
  viewAsAdmin,
  accessLevel,
  newNavigation = false,
}) => {
  const transitions = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 100 },
  });

  return (
    <>
      {transitions((style, item) =>
        item ? (
          <animated.div style={style}>
            <StyledIconPopup $newNavigation={newNavigation}>
              <>
                <b>Viewing as:</b> {viewAsAdmin ? 'Admin' : 'User'}
                <br />
                <b>Access Level:</b>{' '}
                {accessLevel === AccessLevel.ReadWrite ? 'Read & Write' : 'Read'}
                <br />
              </>
              {version && (
                <>
                  <b>Version:</b> {version}
                  <br />
                </>
              )}
              {locale && (
                <>
                  <b>Locale:</b> {locale}
                </>
              )}
            </StyledIconPopup>
          </animated.div>
        ) : null,
      )}
    </>
  );
};

export default CookieOverview;
